import { render, staticRenderFns } from "./assessment-question.vue?vue&type=template&id=60580a46&scoped=true"
import script from "./assessment-question.vue?vue&type=script&lang=js"
export * from "./assessment-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60580a46",
  null
  
)

export default component.exports